<template>
  <el-dialog
      :visible.sync="isShow"
      width="890px"
      class="linkAllDialog"
      :title="title"
      :close-on-click-modal="false"
      top="12vh">

      <div style="display: flex">
        <el-date-picker v-model="recordYear" type="year"
                        placeholder="请选择年份"
                        class="yioks-w100"
                        value-format="yyyy"
                        :clearable = false
                        style="margin-bottom:20px;"
                        @change="changeQuery(true)"/>
      </div>

    <div class="sss" style="height: 530px;padding-bottom: 10px">
      <template>
        <yioks-loading v-if="loading" />
        <template v-else>
          <yioks-empty v-if="empty" :whiteBg="true" style="height:500px;"></yioks-empty>
          <div v-else class="associatContetn"  style="height: 500px">
<!--            <div class="th" style="margin-right: 20px">-->
<!--              <div class="tr img">-->
<!--                <p>序号</p>-->
<!--              </div>-->
<!--              <div class="tr name">-->
<!--                <p>机构名称</p>-->
<!--              </div>-->
<!--              <template v-for="(item1,index) in recordList">-->
<!--                <div class="tr organName">-->
<!--                  <p>{{ item1.recordName }}</p>-->
<!--                </div>-->
<!--              </template>-->
<!--              <div class="tr idNumber">-->
<!--                <p>总积分</p>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div style="height: 420px" class="scollContent">-->
<!--              <vue-scroll :ops="ops">-->
<!--                <div class="list" style="margin-right: 20px">-->
<!--                  <div v-for="(item,index) in rankingList" class="tbody">-->
<!--                    <div class="td img">-->
<!--                      <p>{{ index + 1 }}</p>-->
<!--                    </div>-->
<!--                    <div class="td name">-->
<!--                      <p>{{item.youthShortName}}</p>-->
<!--                    </div>-->
<!--                    <template v-for="(item1,index1) in recordList">-->
<!--                      <div class="td idNumber">-->
<!--                        <p>{{ item[recordList[index1].id] || 0 }}</p>-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <div class="td idNumber">-->
<!--                      <p>{{item.total}}</p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </vue-scroll>-->
<!--            </div>-->

            <vue-scroll  :ops="ops">
              <template v-if="recordType === 'match'">
                <el-table :data="rankingList" style="width: 100%" show-summary :default-sort = "{prop: 'total', order: 'descending'}">
                  <el-table-column type="index" label="序号" width="50"></el-table-column>
                  <el-table-column prop="youthShortName" label="机构名称" width="170" sortable></el-table-column>
                  <template v-for="(item1,index) in recordList">
                    <el-table-column :prop="item1.uuid" :label="item1.recordName" width="190" sortable></el-table-column>
                  </template>
                  <el-table-column prop="total" label="总积分" width="100" sortable></el-table-column>
                </el-table>
              </template>
              <template v-else>
                <el-table :data="rankingList" style="width: 100%" show-summary :default-sort = "{prop: 'total', order: 'descending'}">
                  <el-table-column fixed type="index" label="序号" width="50"></el-table-column>
                  <el-table-column fixed prop="youthShortName" label="机构名称" width="170" sortable></el-table-column>
                  <template v-for="(item1,index) in recordList">
                    <el-table-column :label="item1.recordName">
                      <el-table-column :prop="item1.recordName" label="人次" width="100" sortable></el-table-column>
                      <el-table-column :prop="item1.uuid" label="积分" width="100" sortable></el-table-column>
                    </el-table-column>
                  </template>
                  <el-table-column prop="total" label="总积分" width="100" sortable></el-table-column>
                </el-table>
              </template>
            </vue-scroll>


          </div>
        </template>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import storage from '@/utils/storage'
import { ops } from '@/utils/scrollIndialog'
import record from '@/api/record'
export default {
  name: 'index1',
  components: {
  },
  props: {
    isShowRankingDialog: {
      required: true,
      type: Boolean
    },
    recordType: {
      required: true, // 传入类型
      type: String
    },
    title: {
      required: true,
      type: String
    },
  },
  data () {
    return {
      ops,
      recordYear: "2022",
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      rankingList: [],
      recordList: [],
      loading: true,
      empty: false,
    }
  },
  computed: {
    isShow: {
      get () {
        return this.isShowRankingDialog
      },
      set (val) {
        this.$emit('hideRankingDialog', val, false)
      }
    }
  },
  watch: {
    page(val) {
    }
  },
  created () {
    this.getRecordList() // 获取查询记录列表
  },
  methods: {
    changeQuery(flag) {
      this.getRecordList()
    },

    // 获取查询记录列表
    getRecordList () {
      record.getRecordList(this.recordYear,this.recordType).then((res) => {
        if (res.length){
          this.recordList = res
          this.getRecordAuditRanking() // 查询机构
        }else {
          this.empty = true
        }

      });
    },

    // 查询机构排行榜
    getRecordAuditRanking () {
      record.getRecordAuditRanking(this.recordYear,this.recordType).then((res) => {
        if (res.code) {
          this.$message.error(res.msg)
        }else {
          this.loading = false
          this.empty = false
          this.rankingList = res
          this.rankingList.map((item) => {
            this.recordList.map((item1)=>{
              if (!item[item1.uuid]){
                item[item1.uuid] = 0;
                item[item1.recordName] = 0;
              }else{
                item[item1.uuid] = Number(item[item1.uuid]);
              }
            })
            if (!item.total){
              item.total = 0;
            }
          });
        }
      });
    },
  }
}
</script>

<style  lang="stylus">
@import '~@/assets/css/variable'
.linkAllDialog
  .el-dialog__body
    padding  15px 20px
  .th
    display flex
    height:40px
    justify-content: center;
    align-items: center;
    border-bottom 1px solid gray
    border-top 1px solid gray
    .tr
      height 100%
      flex  1  1 auto
      border-right 1px solid gray
      display flex
      justify-content center
      align-items center
      p
        text-align center
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: black;
    .choose
      width 15%
    .name
      width 15%
    .img
      width 10%
    .organName
      width 20%
    .youthName
      width 20%
    .idNumber
      width 20%
    .opt
      width 15%
  .tbody
    display: flex
    justify-content center
    align-items center
    border-bottom 1px solid gray
    height 49px
    .td
      border-right 1px solid gray
      height 100%
      flex  1  1 auto
      display flex
      justify-content center
      align-items center
      p
        text-align center
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: black;
    .choose
      width 15%
    .name
      width 15%
    .img
      width 10%
    .organName
      width 20%
    .youthName
      width 20%
    .idNumber
      width 20%
    .opt
      width 15%
  .el-pagination
    color black
    .el-pagination__total,.el-pagination__jump
      color black
    .btn-prev,.btn-next
      color black
    ul > li
      color black
    ul > li:hover
      color $green_color
    ul > li.active
      color  $green_color
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: $green_color;
  border-color: $green_color;
}
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.tutorial
  color #999
  font-size 16px
  .item
    padding 10px 0
    border-bottom 1px solid #CCC
    margin 0 20px
    .title
      padding 10px 0 25px 0
      font-size 20px
      font-weight bold
      color #000
    .info_content
      display flex
      .info
        display flex
        flex-direction column
        justify-content center
        flex 1
        p
          margin-bottom 10px
      .btn_wrap
        margin-right 40px
        .btn
          margin-top 10px
          text-align center
</style>
